module.exports = "https://staticsandbox.coteibem.com.br/assets/fallback-image.3bf3adacd40b54b657d9fb2b2e9adaa8.svg";